import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { TransitionTrigger } from './transition-trigger';

export class EnrolmentInformationMissingTrigger extends TransitionTrigger {
	public orderingNumber = 33;

	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Missing information', excludedEnrolmentStatuses);
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentInformationMissingTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>): Promise<void> {
		await EnrolmentService.triggerEnrolmentInformationMissing(enrolments);
	}
}
